import {
  DEFAULT_ICON_BUTTON_CLASS_NAME,
  COMPACT_ICON_BUTTON_CLASS_NAME,
  GO_BACK_ICON_BUTTON_CLASS_NAME,
  RED_SQUARE_FILLED_ICON_BUTTON_CLASS_NAME,
  PRIMARY_SQUARE_OUTLINED_ICON_BUTTON_CLASS_NAME,
} from '../../constants/icon-button';

const defaultIconButton = ({ theme }) => ({
  '& .MuiSvgIcon-root': {
    color: theme.palette.primary.main,
  },
});

const compactIconButton = ({ theme }) => ({
  padding: theme.spacing(0.2),
});

const goBackIconButton = ({ theme }) => ({
  width: 30,
  height: 30,
  [theme.breakpoints.up('md')]: {
    width: 48,
    height: 48,
  },
});

const redSquareFilledIconButton = ({ theme }) => ({
  maxWidth: 39,
  maxHeight: 39,
  borderRadius: theme.shape.borderRadius * 2,
  color: theme.palette.common.white,
  backgroundColor: theme.palette.error.A600,
  '&:hover': {
    backgroundColor: theme.palette.error.A700,
    color: theme.palette.common.white,
  },
  '&.Mui-disabled': {
    color: theme.palette.action.disabled,
    backgroundColor: theme.palette.gray.A300,
  },
});

const primarySquareOutlinedIconButton = ({ theme }) => ({
  padding: theme.spacing(1),
  border: '1px solid',
  borderColor: 'currentColor',
  borderRadius: theme.shape.borderRadius * 2,
  color: theme.palette.primary.main,
  '& .MuiSvgIcon-root': {
    fontSize: '20px',
  },
  '&:hover': {
    backgroundColor: 'transparent',
    opacity: 0.8,
  },
  '&.Mui-disabled': {
    color: theme.palette.action.disabled,
    backgroundColor: 'transparent',
  },
});

const MuiIconButton = {
  styleOverrides: {
    root: ({ theme }) => ({
      [`&.${DEFAULT_ICON_BUTTON_CLASS_NAME}`]: defaultIconButton({ theme }),
      [`&.${COMPACT_ICON_BUTTON_CLASS_NAME}`]: compactIconButton({ theme }),
      [`&.${GO_BACK_ICON_BUTTON_CLASS_NAME}`]: goBackIconButton({ theme }),
      [`&.${RED_SQUARE_FILLED_ICON_BUTTON_CLASS_NAME}`]: redSquareFilledIconButton({ theme }),
      [`&.${PRIMARY_SQUARE_OUTLINED_ICON_BUTTON_CLASS_NAME}`]: (
        primarySquareOutlinedIconButton({ theme })
      ),
    }),
  },
};
export default MuiIconButton;
